import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomGridService } from '../../../../../customgrid';
import { ComboProperty, QResult, QueovalBase, Select } from '../../../../../models';
import { CoreService, HttpService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';
import { DocumentService } from '../document.service';
import { ModeEffectif, Option } from '../../../../../models/effectif/option.model';
import { StageDocumentFormationModel, StageDocumentUpdate } from '../../../../../models/formation';
import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { GenericEffectif } from '../../../../../models/effectif/genericEffectif.model';
import { DynamictagsInlineComponent } from '../../../../../bodisplay/dynamictags-inline';
import { Subject, Subscription } from 'rxjs';
import { DocxPreselect } from '../../../../../models/document/model.docx.preselect';

@Component({
  selector: 'queoval-stage-generation-documents',
  templateUrl: './generation-documents.component.html',
  styleUrls: ['./generation-documents.component.css']
})
export class GenerationDocumentsComponent implements OnInit {

  @Input('refreshGrid') set SetRefreshGrid(value: boolean) {
    if (value) {
      this.refreshData = value;
      setTimeout(() => { this.refreshGridChange.emit(false); }, 250);
    }
  }
  @Output() refreshGridChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('dynamictagsInline') dynamictagsInline: DynamictagsInlineComponent;

  //#region Variables globals
  public ModelsList: Array<Select> = [];
  public selectedModel: Select = new Select('', '- - - - - -');

  public selectedModel$ = new Subject<Select>();
  private subscription: Subscription;

  public ModeGeneration: number = 2;

  public OptionStagiaire: Option;
  public OptionClient: Option;
  /** ident formateur pour ListReservationComponent (Input) */
  public IdentFormateur: string;

  public refreshData: boolean;

  public selectedNodes: RowNode[];

  public isGenerating: boolean = false;
 

  public model: StageDocumentFormationModel = new StageDocumentFormationModel();
  public emptyModel = false;

  public docxpreselect$ = new Subject<DocxPreselect>();

  //#endregion Variables globals

  constructor(
    public service: StageService,
    public docService: DocumentService,
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
    private modalService: NgbModal,
    private customGridService: CustomGridService
  ) { }


  ngOnInit(): void {
    this.OptionStagiaire = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.STAGIAIREMAIL);
    this.OptionClient = new Option(this.service.Stage.Ident, this.service.Stage.Ident, ModeEffectif.CLIENTMAIL);
    
    this.IdentFormateur = "";
    this.http.getHttp<QResult<ComboProperty>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/MODELES_DOCUMENT/0`).subscribe
      ((result: QResult<ComboProperty>) => {
       // this.selectedModel.id = result.Value.DefaultProperty;
        this.ModelsList = result.Value.ListProperty;
        //this.selectedModel$.next(this.selectedModel);
        this.subscription = this.selectedModel$.subscribe(valeur => {
          this.selectedModel = valeur;
          if (this.selectedModel.id != '') {
            this.http.getHttp<QResult<DocxPreselect>>(`${this.indParam.AppParams.apiUrl}api/modeldocx/get/${this.selectedModel.id}`).subscribe((response: QResult<DocxPreselect>) => {
              switch (response.Value.Unitaire) {
                case '1':
                  this.ModeGeneration = 1;
                  break;
                case '2':
                  this.ModeGeneration = 2;
                  break;
                case '3':
                  this.ModeGeneration = 3;
                  break;
              }
              if (response.Value.Rapport != null && response.Value.Rapport != "") {

                this.model.IdReport = response.Value.Rapport;
              }
              else {
                this.model.IdReport = "0";
              }
              this.docxpreselect$.next(response.Value);
            }
            );
          }
        });

      })


  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  //#region Fonctions Publics

  /**
   * recupère la liste d'ident des réservations par rapport
   * à l'Output du composant ListReservationComponent
   * @param event Liste d'ident des reservations
   */
  public GetReservations(event: Array<string>) {
    this.model.Reservations = event;
  }

  public UpdateListEffectif(effectifs: Array<GenericEffectif>, mode: string): void {
    const ids: string[] = effectifs.filter(effectif => effectif.IsSelected).map(effectif => effectif.Id);
    switch (mode) {
      case 'CLIENT':
        this.model.Clients = ids;
        break;
      case 'CONTACT':
        this.model.Stagiaires = ids;
        break;
    }
  }

  public getListSelected(): Array<string> {
    let liste: Array<string> = [];
    this.model.Stagiaires.forEach(r => { liste.push(r) });
    return liste;
  }

  public GenerateDocs(): void {
    if (this.isGenerating) {
      this.toast.showInfoToast('Génération en cours');
      return;
    }

    if (!this.selectedModel.id) {
      this.emptyModel = true;
    }
    if (!this.dynamictagsInline.HasEmptyProp() && !this.emptyModel) {
      this.isGenerating = true;
      this.model.IdStage = this.service.Stage.Ident;
      this.model.Model = this.selectedModel.id;
      this.model.ModeSeparation = this.ModeGeneration == 1 ? 'CONTACT' : this.ModeGeneration == 3 ? 'CLIENT' : '';
      this.http.postHttp<QResult<Array<string>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/CREATE_DOCUMENT`, this.model).subscribe((result: QResult<Array<string>>) => {

        if (result.Value && result.Value.length > 0) {
          result.Value.forEach(ident => {
            if (ident && ident != "0") {
              this.dynamictagsInline.idDonnee = ident;
              this.dynamictagsInline.OnSave().subscribe(() => {
                this.isGenerating = false;
                this.dynamictagsInline.idDonnee = "0";
                this.refreshGridChange.emit(true);
              });
            }
          });
        }
        else {
          this.isGenerating = false;
          this.refreshGridChange.emit(true);
        }
        if (!result.HasAlert)
          this.toast.showSuccessToast('Document généré');
      });
    }
  }


  /* 
 * Permet de recharger la grid
 */
  public refreshGrid(): void {
    this.refreshGridChange.emit(true);
  }

  /*
 * Permet d'avoir les lignes selectionnées
 */
  public selectLine(event: SelectionChangedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
* 
* @param Modal la modal qui doit être ouverte
* @param xl si oui la modal est grande, sinon elle est de taille réduite
*/
  public open(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
    } else {
      this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }


  /*
 * Supprimer les documents selectionnés
 */
  public DeleteSelection() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;

    this.http.postHttp<QResult<StageDocumentUpdate>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/DELETE_DOC`, documentModel).subscribe(
      (result: QResult<StageDocumentUpdate>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) supprimé(s)");
          this.refreshGrid();
          this.selectedNodes = [];
        }
        this.indParam.showSplash(false);
      });
  }


  /*
 * Regénération des documents selectionnés
 */
  public RegenereDoc() {
    let documentModel = new StageDocumentUpdate();
    documentModel.DocumentIdentList = new Array<string>();
    this.selectedNodes.forEach((document) => {
      documentModel.DocumentIdentList.push(document.data.Ident)
    });
    documentModel.StringData = this.service.Stage.Ident;
    documentModel.TypeDocument = "COURRIER";
    this.http.postHttp<QueovalBase>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/GENERATE_DOC`, documentModel).subscribe(
      (result: QueovalBase) => {
        if (!result.HasError) {
          this.toast.showSuccessToast("Document(s) généré(s)");
          this.refreshGrid();
          this.selectedNodes = [];
        }
        this.indParam.showSplash(false);
      });
  }
  //#endregion Fonctions Publics



}
